import { SessionClaimStatus } from '../constants';

import type { GetIsRowDisabled } from './types/claimSessionTableRow';

export const getIsRowDisabled: GetIsRowDisabled = (
  status,
  readonly,
  providerLicensesLoading,
  providerPayorCredentialsLoading,
) =>
  status !== SessionClaimStatus.Unclaimed ||
  !!readonly ||
  !!providerLicensesLoading ||
  !!providerPayorCredentialsLoading;
